import axios, { AxiosRequestConfig } from 'axios';
import { stringify } from 'qs';
import errorStatusCodeConformer from './interceptors/error-status-code-conformer';
import xsrfTokenRequestDecorator from './interceptors/xsrf-token-request-decorator';
import { APP_ECC, APP_PPC, ECC_STARGATE_PREFIX, PPC_STARGATE_PREFIX } from '../../constants';
//TODO move values to constants

export enum ServiceProxyMap {
  ANS = '/css-xp-ans',
  SUPPORT = '/css-xp-support',
  AUTH = '/css-xp-auth',
  SXP = '/css-xp-sell-svc',
  APD = '/css-xp-apr-desk-svc',
  APD_V2 = '/css-xp-apr-desk-svc-v2',
  BLAZE = '/blaze-api-entitlement',
  PPC_BFF = '',
  CCP = '/ccp',
  PAPI = '/partner-hub',
}

export enum ProxyGraphClients {
  ANS = 'ANS',
  AUTH = 'AUTH',
  SXP = 'SXP',
  APD = 'APD',
  APD_V2 = 'APD_V2',
  PPC_BFF = 'PPC_BFF',
  PAPI = 'PAPI',
}

export const getPrefixURL = (service: ProxyGraphClients) => {
  switch (process.env.APP_NAME) {
    case APP_PPC: {
      return PPC_STARGATE_PREFIX + ServiceProxyMap[service];
    }
    default: {
      // this is for docker, since we use UI server in local as well proxy is still needed
      // assuming only docker will run app on 5000
      if (window.location.hostname.indexOf('localhost') === -1 || window.location.host === 'localhost:5000') {
        return ServiceProxyMap[service];
      }
      return '';
    }
  }
};

export default function createAxiosClient(config: AxiosRequestConfig = {}, destination: string) {
  const defaultConfig = {
    paramsSerializer: (params: any) => stringify(params),
  };

  switch (process.env.APP_NAME) {
    case APP_PPC: {
      config.baseURL = PPC_STARGATE_PREFIX + destination + config.baseURL;
      break;
    }
    case APP_ECC: {
      config.baseURL = ECC_STARGATE_PREFIX + destination + config.baseURL;
      break;
    }
    default: {
      // this is for docker, since we use UI server in local as well proxy is still needed
      // assuming only docker will run app on 5000
      if (window.location.hostname.indexOf('localhost') === -1 || window.location.host === 'localhost:5000') {
        config.baseURL = destination + config.baseURL;
      }
    }
  }

  const client = axios.create({
    ...defaultConfig,
    ...config,
  });

  client.interceptors.request.use(xsrfTokenRequestDecorator);
  client.interceptors.response.use(undefined, errorStatusCodeConformer);

  return client;
}
